import(/* webpackMode: "eager" */ "/vercel/path0/app/background-remover/page.tsx");
